import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentTransactions = ({ transactions, merchantId }) => {
  const navigate = useNavigate();

  const getStatusBadge = (status) => {
    const configs = {
      success: { color: 'bg-success/10 text-success border-success/20', label: 'Success', icon: 'CheckCircle' },
      pending: { color: 'bg-warning/10 text-warning border-warning/20', label: 'Pending', icon: 'Clock' },
      failed: { color: 'bg-error/10 text-error border-error/20', label: 'Failed', icon: 'XCircle' }
    };
    const config = configs?.[status] || configs?.pending;
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border ${config?.color}`}>
        <Icon name={config?.icon} size={12} />
        {config?.label}
      </span>
    );
  };

  const formatCurrency = (amount) => {
    return `Rp ${(amount || 0)?.toLocaleString('id-ID')}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date?.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Recent Transactions</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(`/merchants/${merchantId}/transactions`)}
          className="flex items-center gap-2 text-primary"
        >
          View All
          <Icon name="ArrowRight" size={16} />
        </Button>
      </div>

      {transactions?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Receipt" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No transactions yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {transactions?.map((transaction) => (
            <div key={transaction?.id} className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/30 transition-colors">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <p className="text-sm font-medium text-foreground">{transaction?.transactionId}</p>
                  {getStatusBadge(transaction?.status)}
                </div>
                <p className="text-xs text-muted-foreground">{formatDate(transaction?.createdAt)}</p>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-foreground">{formatCurrency(transaction?.amount)}</p>
                <p className="text-xs text-muted-foreground capitalize">{transaction?.paymentMethod}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentTransactions;